(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mix-radio"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('mix-audio')){customElements.define('mix-audio',class extends HTMLElement{
connectedCallback(){if(this.controller)return;this.controller=new AbortController();const options={signal:this.controller.signal};this.audio=this.querySelector('audio');this.toggle=this.querySelector('.mr-audio-toggle');this.seek=this.querySelector('.mr-audio-seek');this.wave=this.querySelector('.mr-wave');this.status=this.querySelector('.mr-audio-status');this.current=this.querySelector('[data-current]');this.duration=this.querySelector('[data-duration]');this.querySelector('.mr-player-controls').hidden=false;this.classList.add('mr-player-ready');const time=value=>{if(!Number.isFinite(value))return '--:--';const seconds=Math.floor(value);return Math.floor(seconds/60)+':'+String(seconds%60).padStart(2,'0');};const update=()=>{const total=this.audio.duration;this.current.textContent=time(this.audio.currentTime);this.duration.textContent=time(total);this.seek.disabled=!(Number.isFinite(total)&&total>0);const progress=this.seek.disabled?0:this.audio.currentTime/total*100;this.seek.value=progress;this.wave.style.setProperty('--progress',progress+'%');this.seek.setAttribute('aria-valuetext',time(this.audio.currentTime)+' / '+time(total));};const playback=()=>{const playing=!this.audio.paused;this.toggle.setAttribute('aria-pressed',String(playing));this.toggle.setAttribute('aria-label',playing?this.dataset.pause:this.dataset.play);this.closest('.mr').classList.toggle('mr-is-playing',playing);};this.toggle.addEventListener('click',async()=>{if(this.audio.paused){this.status.textContent='';try{await this.audio.play();}catch{this.status.textContent=this.dataset.error;}}else this.audio.pause();},options);this.seek.addEventListener('input',()=>{if(Number.isFinite(this.audio.duration)&&this.audio.duration>0)this.audio.currentTime=Number(this.seek.value)/100*this.audio.duration;},options);for(const event of ['loadedmetadata','durationchange','timeupdate'])this.audio.addEventListener(event,update,options);for(const event of ['play','pause','ended'])this.audio.addEventListener(event,playback,options);this.audio.addEventListener('error',()=>{this.status.textContent=this.dataset.error;},options);update();playback();}
disconnectedCallback(){this.audio?.pause();this.controller?.abort();this.controller=null;}
});}
document.addEventListener('click',function(event){const link=event.target.closest('[data-mix-duration]');if(!link)return;const section=link.closest('.mr');const select=section.querySelector('.mr-form select[name="id"]');const duration=link.dataset.mixDuration;const index=Array.from(select.options).findIndex(option=>option.textContent.trim().split(' ')[0]===duration);if(index>=0){select.selectedIndex=index;select.dispatchEvent(new Event('change',{bubbles:true}));}});


if(!customElements.get('mix-pronunciation'))customElements.define('mix-pronunciation',class extends HTMLElement{
connectedCallback(){if(this.controller)return;this.controller=new AbortController();const opt={signal:this.controller.signal};this.text=this.querySelector('textarea');this.file=this.querySelector('input[type=file]');this.link=this.querySelector('input[type=url]');this.player=this.querySelector('[data-preview]');this.start=this.querySelector('[data-record]');this.stop=this.querySelector('[data-stop]');this.remove=this.querySelector('[data-remove]');this.timer=this.querySelector('[data-timer]');this.status=this.querySelector('[role=status]');this.form=this.closest('form');this.text.addEventListener('input',()=>this.validate(),opt);this.link.addEventListener('input',()=>this.validate(),opt);this.file.addEventListener('change',()=>this.setAudio(),opt);this.remove.addEventListener('click',()=>{this.file.value='';this.setAudio();},opt);this.start.hidden=!(navigator.mediaDevices?.getUserMedia&&window.MediaRecorder&&window.DataTransfer);this.start.addEventListener('click',()=>this.record(),opt);this.stop.addEventListener('click',()=>this.endRecording(),opt);this.form.addEventListener('submit',event=>{this.validate();if(this.recording||!this.form.reportValidity())event.preventDefault();},opt);this.validate();}
validate(){const present=!!(this.text.value.trim()||this.file.files.length||this.link.value.trim());this.text.required=!present;this.text.setCustomValidity(present?'':this.dataset.required);}
setAudio(){const file=this.file.files[0];let error='';if(file&&file.size>5*1024*1024)error=this.dataset.size;else if(file&&!/\.(mp3|wav|m4a|ogg|webm)$/i.test(file.name)&&!file.type.startsWith('audio/'))error=this.dataset.type;if(error)this.file.value='';if(this.objectURL)URL.revokeObjectURL(this.objectURL);this.player.pause();this.player.removeAttribute('src');this.player.hidden=!this.file.files.length;this.remove.hidden=!this.file.files.length;if(this.file.files.length){this.objectURL=URL.createObjectURL(this.file.files[0]);this.player.src=this.objectURL;}this.status.textContent=error||(this.file.files.length?this.dataset.ready:'');this.validate();}
async record(){if(this.pending||this.recording)return;this.pending=true;this.start.disabled=true;try{const stream=await navigator.mediaDevices.getUserMedia({audio:true});if(!this.isConnected){stream.getTracks().forEach(track=>track.stop());return;}this.stream=stream;const mime=['audio/webm;codecs=opus','audio/ogg;codecs=opus','audio/mp4'].find(type=>MediaRecorder.isTypeSupported(type));this.recorder=mime?new MediaRecorder(stream,{mimeType:mime}):new MediaRecorder(stream);const chunks=[];this.recorder.ondataavailable=event=>{if(event.data.size)chunks.push(event.data);};this.recorder.onstop=()=>{clearInterval(this.interval);stream.getTracks().forEach(track=>track.stop());this.recording=false;this.start.hidden=false;this.stop.hidden=true;this.file.disabled=false;this.timer.textContent='';if(!this.isConnected)return;const type=this.recorder.mimeType||'audio/webm';const ext=type.includes('ogg')?'ogg':type.includes('mp4')?'m4a':'webm';const transfer=new DataTransfer();transfer.items.add(new File(chunks,'pronunciacion-emisora.'+ext,{type}));this.file.files=transfer.files;this.setAudio();};this.recorder.start();this.recording=true;this.start.hidden=true;this.stop.hidden=false;this.file.disabled=true;this.status.textContent=this.dataset.active;let seconds=0;this.timer.textContent='0:00 / 0:30';this.interval=setInterval(()=>{seconds++;this.timer.textContent='0:'+String(seconds).padStart(2,'0')+' / 0:30';if(seconds>=30)this.endRecording();},1000);}catch{this.stream?.getTracks().forEach(track=>track.stop());this.status.textContent=this.dataset.error;}finally{this.pending=false;this.start.disabled=false;}}
endRecording(){if(this.recorder?.state==='recording')this.recorder.stop();}
disconnectedCallback(){this.controller?.abort();this.controller=null;clearInterval(this.interval);this.endRecording();this.stream?.getTracks().forEach(track=>track.stop());if(this.objectURL)URL.revokeObjectURL(this.objectURL);}
});


  } catch(e) { console.error(e); }
})();
})();
